import { render, staticRenderFns } from "./babyTicketAppraiseDetails.vue?vue&type=template&id=024e0568&scoped=true&"
import script from "./babyTicketAppraiseDetails.vue?vue&type=script&lang=js&"
export * from "./babyTicketAppraiseDetails.vue?vue&type=script&lang=js&"
import style0 from "./babyTicketAppraiseDetails.vue?vue&type=style&index=0&id=024e0568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024e0568",
  null
  
)

export default component.exports